import type {
  ExperimentConfig,
  FeatureFlagConfig,
} from '@seek/candidate-feature-flag';

export const EXPERIMENT_KEYS = {
  LINKOUT_RECS: 'experiment-linkout-job-recommendations',
};

/**
 * NOTE: LaunchDarkly usage at SEEK
 *
 * - We only use **feature flags** for experimentation (not LD "experiments").
 * - `experimentsConfig`: list of flags tracked as experiments. Needed if you call `useExperimentsEligibleProps`.
 *   Flags not in this array are treated as releases/permanent toggles and won't be tracked.
 * - `featureFlagsConfig`: same as above but without tracking.
 *
 * `trackingNumber`: legacy field for Tealium tracking. Not required for Hubble.
 *   Until fully removed, you can pass any number if your DA doesn't need it.
 *
 * Only use experimentsConfig - if you put the same key in both, it results in duplication in tracking data
 * I don't know why this is, if featureFlagsConfig is supposed to not track.
 * This is still new technology at SEEK, so I imagine it will be cleaned up soon.
 */

export const featureFlagsConfig: FeatureFlagConfig[] = [];

export const experimentsConfig: ExperimentConfig[] = [
  { key: 'experiment-aa-test-for-apex-candidate', trackingNumber: 1 },
  {
    key: EXPERIMENT_KEYS.LINKOUT_RECS,
    trackingNumber: 3,
    type: 'string',
    title: 'Experiment: Linkout Job Recommendations',
    variations: ['champion', 'challenger', 'ineligible', 'unauthenticated'],
  },
];
